<template>
  <div class="login">
    <div class="login__form">
      <div class="pt-4">
        <v-card>
          <v-toolbar
            light
            color="white"
            class="elevation-2"
          >
            <v-toolbar-title>
              Zmień hasło
            </v-toolbar-title>
          </v-toolbar>
          <div class="py-2 pt-4">
            <div class="px-4">
              <v-text-field
                v-model.trim="formData.current_password"
                label="Stare hasło"
                :type="'password'"
                :error-messages="errors.collect('current_password')"
                v-validate="'required|min:6|max:20'"
                data-vv-name="current_password"
                data-vv-as="stare hasło"
                required
              ></v-text-field>
            </div>
            <div class="px-4">
              <v-text-field
                v-model.trim="formData.password"
                ref="password"
                label="Nowe hasło"
                :type="'password'"
                data-vv-delay="1000"
                :error-messages="errors.collect('password')"
                v-validate="'required|min:6|max:20'"
                data-vv-name="password"
                data-vv-as="nowe hasło"
                hint="Hasło musi mieć od 6 do 20 znaków, musi zawierać co najmniej:
        jedną małą literę, jedną wielką literę, jedną liczbę oraz jeden znak specjalny"
                required
              ></v-text-field>
            </div>
            <div class="px-4 pb-2">
              <v-text-field
                v-model.trim="formData.password_confirmation"
                label="Powtórz nowe hasło"
                :type="'password'"
                data-vv-delay="1000"
                :error-messages="errors.collect('repeat_password')"
                v-validate="'confirmed:password'"
                data-vv-name="repeat_password"
                data-vv-as="nowe hasło"
                required
              ></v-text-field>
            </div>
          </div>
          <v-card-actions class="px-4 pb-4">
            <ServerErrors :errorsItems="serverErrors" />
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :loading="busy"
              :disabled="busy"
              @click="storePassword"
            >
              Zapisz
            </v-btn>
          </v-card-actions>
        </v-card>

      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { setPassword } from '../../repository/auth';
import { getError } from '../../helpers/helpers';
import ServerErrors from '../common/Errors/ServerErrors.vue';

export default {
  name: 'chnage-password',
  data: () => ({
    errorMsg: null,
    error: false,
    serverErrors: [],
    formData: {
      current_password: null,
      password: null,
      password_confirmation: null,
    },
    busy: false,
  }),
  components: {
    ServerErrors,
  },
  computed: {
    ...mapGetters('user', [
      'needNewPassword',
    ]),
  },
  methods: {
    ...mapActions('user', [
      'setNeedPassword',
    ]),
    getServerErrors(errors) {
      const filedKeys = Object.keys(errors);
      filedKeys.forEach((fieldKey) => {
        const fieldErros = errors[fieldKey];
        if (!fieldErros[0] || fieldErros.length <= 0) return;
        fieldErros.forEach((err) => {
          const field = this.$validator.fields.find({
            name: fieldKey,
            scope: this.$options.scope,
          });
          if (field) {
            this.$validator.errors.add({
              id: field.id,
              field: fieldKey,
              msg: err,
              scope: this.$options.scope,
            });
            field.setFlags({
              invalid: true,
              valid: false,
              validated: true,
            });
          } else if (!this.serverErrors.includes(err)) {
            this.serverErrors.push(err);
          }
        });
      });
    },
    getError(errorData) {
      this.dialogBusy = false;
      this.busy = false;
      this.errorMsg = getError(errorData);
      this.error = true;
      if (errorData.response.data && errorData.response.data.data) {
        this.getServerErrors(errorData.response.data.data);
      }
    },
    setVisbility() {
      this.setDialogVisbility(false);
    },
    clearData() {
      this.$validator.reset();
      this.busy = false;
      this.errorMsg = null;
      this.error = null;
      this.serverErrors = [];
      this.formData = {
        current_password: null,
        password: null,
        password_confirmation: null,
      };
    },
    storePassword() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.setNewPassword();
        }
      });
    },
    redirectToDashBoard() {
      if (!this.needNewPassword) {
        this.$router.push('/');
      }
    },
    async setNewPassword() {
      this.busy = true;
      try {
        await setPassword(this.formData);
        this.setNeedPassword(false);
        this.redirectToDashBoard();
        this.busy = false;
        this.clearData();
      } catch (e) {
        this.getError(e);
      }
    },
  },
  mounted() {
    this.redirectToDashBoard();
  },
};
</script>
